import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController, Platform } from '@ionic/angular/lazy';
import { OrderService } from 'src/app/services/order.service';
import { CourierService } from 'src/app/services/courier.service';
import { AuthService } from 'src/app/services/auth.service';
import { APIService } from 'src/app/services/api.service';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';
import { Printer } from 'capacitor-printer';
import { Router } from '@angular/router';
import moment from 'moment-timezone';
import { ObserverService } from 'src/app/services/observer.service';
import { SupportedCurrencyService } from 'src/app/services/supported-currency.service';
import printJS from 'print-js';
import { StorageService } from 'src/app/services/storage.service';
import { DesktopPrintClientService } from 'src/app/services/desktop-print-client.service';
import { Capacitor } from '@capacitor/core';
import { Decimal } from "decimal.js";

@Component({
    selector: 'app-order-fulfillment-add',
    templateUrl: './order-fulfillment-add.page.html',
    styleUrls: ['./order-fulfillment-add.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderFulfillmentAddPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    moment = moment;
    order_params = {};
    @Input() order_id = null;
    order = null;
    couriers = null;
    locations = null;
    countries = null;
    date_modal_css_class = '';
    shipping_address_country = null;
    item_quantity = 0;
    formatted_date = null;
    fulfillable_items = [];
    base_currency = null;
    order_payment_owing = false;
    customer_amount_owing = false;
    customer_credit_limit_exceeded = false;
    on_device = false;
    printer_paper_sizes = [];
    desktop_print_client_enabled = false;

    fulfillment_params = {
        items: [],
        method: 'collected',
        location_id: '',
        send_order_shipped_email: false,
        courier_id: '',
        courier_tracking_number: null
    }

    method_select_options: any = {
        header: 'Method'
    };

    courier_select_options: any = {
        header: 'Courier'
    };

    location_select_options: any = {
        header: 'Location'
    };

    // modal flags
    date_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private loadingController: LoadingController,
        private orderService: OrderService,
        private courierService: CourierService,
        private observerService: ObserverService,
        private supportedCurrencyService: SupportedCurrencyService,
        private storageService: StorageService,
        private desktopPrintClientService: DesktopPrintClientService,
        private apiService: APIService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.date_modal_css_class = 'backdrop';
            this.on_device = true;
        }

        this.storageService.get("printer_paper_sizes").then((printer_paper_sizes) => {
            if(printer_paper_sizes) {
                this.printer_paper_sizes = printer_paper_sizes;
            }
        });

        this.storageService.get("desktop_print_client_enabled").then((desktop_print_client_enabled) => {
            if(desktop_print_client_enabled) {
                this.desktop_print_client_enabled = desktop_print_client_enabled;
            }
        });

        if(this.order_id) {


            this.fulfillment_params['date'] = this.moment().toISOString(true);
            this.formatted_date = this.moment(this.fulfillment_params['date']).format("D MMM YYYY, HH:mm");

            this.fulfillment_params['method'] = 'shipped';

            this.loadData().then(() => {

                if(this.order.fulfillment_location) {
                    this.fulfillment_params['location_id'] = this.order.fulfillment_location.id;
                }

                if(this.order.person && this.order.person.email_address) {
                    this.fulfillment_params.send_order_shipped_email = true;
                }

                // TODO:
                // this.storageService.get("default_courier_id").then(default_courier_id => {
                //     this.fulfillment_params.courier_id = default_courier_id;
                // });

                for(let i = 0; i < this.order.items.length; i++) {
                    if(this.order.items[i].fulfillable_quantity != 0) {
                        let item = {};
                        item['id'] = this.order.items[i].id;
                        item['title'] = this.order.items[i].title;
                        item['fulfillable_quantity'] = this.order.items[i].fulfillable_quantity;
                        item['quantity'] = this.order.items[i].fulfillable_quantity;
                        item['quantity_decimal_places'] = this.order.items[i].quantity_decimal_places;

                        if(this.order.items[i].sku) {
                            item['sku'] = this.order.items[i].sku;
                        }

                        if(this.order.items[i].measurement_unit) {
                            item['measurement_unit'] = this.order.items[i].measurement_unit;
                        }

                        if(this.order.items[i].type == 'product' && this.order.items[i].product) {
                            item['track_stock'] = this.order.items[i].product.track_stock;
                            item['stock_on_hand'] = this.order.items[i].product.stock_on_hand;
                        }
                        else if(this.order.items[i].type == 'product_variant' && this.order.items[i].product_variant) {
                            item['track_stock'] = this.order.items[i].product_variant.track_stock;
                            item['stock_on_hand'] = this.order.items[i].product_variant.stock_on_hand;
                        }

                        this.fulfillable_items.push(item);
                    }
                }

                if(this.order.payment_status != 'paid') {
                    this.order_payment_owing = true;
                }

                if(this.order.organisation) {
                    if(this.order.organisation.amount_owing > 0) {
                        this.customer_amount_owing = true;
                    }
                    if(this.order.organisation.credit_limit && this.order.organisation.amount_owing > this.order.organisation.credit_limit) {
                        this.customer_credit_limit_exceeded = true;
                    }
                }
                else if(this.order.person) {
                    if(this.order.person.amount_owing > 0) {
                        this.customer_amount_owing = true;
                    }
                    if(this.order.person.credit_limit && this.order.person.amount_owing > this.order.person.credit_limit) {
                        this.customer_credit_limit_exceeded = true;
                    }
                }

            })
            .catch(() => { });

        }

        this.observerService.subscribe('network_status_changed|order_fulfillment_add_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to add a fulfillment, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|order_fulfillment_add_modal");
    }

    loadData() {

        return new Promise<void>((resolve, reject) => {

            this.presentSpinner("Loading order").then(() => {

                this.loadOrder().then(() => {

                    this.spinner.message = "Loading couriers";

                    this.loadCouriers().then(() => {

                        this.spinner.message = "Loading locations";

                        this.loadLocations().then(() => {

                            if(this.locations && this.locations.length > 0) {
                                this.fulfillment_params['location_id'] = this.locations[0].id;
                            }

                            this.spinner.message = "Loading supported currency";

                            this.supportedCurrencyService.getBaseSupportedCurrency().then((base_currency) => {

                                if(base_currency) {
                                    this.base_currency = base_currency;
                                }

                                this.spinner.dismiss();
                                resolve();

                            })
                            .catch(() => {
                                this.spinner.dismiss();
                                reject();
                            });
                        })
                        .catch(() => {
                            this.spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadOrder() {
        let promise = new Promise<void>((resolve, reject) => {
            this.order = null;
            this.orderService.getOrder(this.order_id).then((order) => {
                if(order) {
                    this.order = order;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    loadCouriers() {
        let promise = new Promise<void>((resolve, reject) => {
            this.couriers = null;
            this.courierService.getCouriers().then((couriers) => {
                if(couriers) {
                    this.couriers = couriers;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    loadLocations() {
        let promise = new Promise<void>((resolve, reject) => {
            this.locations = null;
            this.apiService.getLocations().then((locations: []) => {
                if(locations) {
                    this.locations = locations;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    // NOTE: always A4
    async printPackingSlip() {

        let format = "pdf_base64";

        let printing_dpc = false;
        if(!this.on_device && this.desktop_print_client_enabled) {
            if(this.desktopPrintClientService.ws_ready) {
                printing_dpc = true;
            }
            else {
                const connect_result = await this.desktopPrintClientService.connectPresent();
                if(connect_result === 'cancel') return;
                if(connect_result === 'connected') printing_dpc = true;
            }
        }

        this.presentSpinner('Printing packing slip').then(() => {

            let items = [];
            for(let i = 0; i < this.fulfillable_items.length; i++) {
                let item = this.fulfillable_items[i];
                if(item['quantity'] > 0) {
                    items.push({
                        id: item['id'],
                        quantity: item['quantity']
                    });
                }
            }

            this.orderService.getOrderPackingSlip(this.order.id, format, items).then(async (packing_slip_content: any) => {
                if(packing_slip_content) {
                    if(this.on_device) {
                        Printer.printBase64({
                            name: 'Packing slip',
                            data: packing_slip_content,
                            mimeType: 'application/pdf'
                        });
                    }
                    else {
                        if(printing_dpc) {
                            await this.desktopPrintClientService.printDocument({
                                document_type: 'packing-slip',
                                document_name: `Packing slip #${this.order.number}`,
                                printer_type: "a4",
                                file_extension: 'pdf',
                                content: packing_slip_content
                            });
                        }
                        else {
                            printJS({
                                printable: packing_slip_content,
                                type: 'pdf',
                                base64: true
                            });
                        }
                    }
                }
            })
            .catch(() => {
                this.spinner.dismiss();
            })
            .finally(() => {
                this.spinner.dismiss();
            })
        });
    }

    close() {
        this.modalController.dismiss();
    }

    clearCourier() {
        this.fulfillment_params.courier_id = "";
    }

    adjustItemQuantity(item_id, change_mode){
        for(let i = 0; i < this.fulfillable_items.length; i++) {
            if(item_id == this.fulfillable_items[i].id) {
                let step = Math.pow(10, -this.fulfillable_items[i].quantity_decimal_places);
                if(change_mode === 'add'){
                    if(this.fulfillable_items[i].quantity < this.fulfillable_items[i].fulfillable_quantity){
                        this.fulfillable_items[i].quantity = Number(new Decimal(this.fulfillable_items[i].quantity).plus(step));
                    }
                }
                else if(change_mode === 'subtract'){
                    if(this.fulfillable_items[i].quantity > 0){
                        this.fulfillable_items[i].quantity = Number(new Decimal(this.fulfillable_items[i].quantity).minus(step));
                    }
                }
                break;
            }
        }
    }

   add() {

        let validated = true;
        let fulfillment_has_items = false;

        if(!this.fulfillment_params['method'] || !this.fulfillment_params['method'].length) {
            this.presentAlert('Missing method', 'Please select a fulfillment method.');
            return;
        }
        else if((this.fulfillment_params['method'] == 'collected' || this.fulfillment_params['method'] == 'shipped') && (!this.fulfillment_params['location_id'] || !this.fulfillment_params['location_id'].length)) {
            this.presentAlert('Missing location', 'Please select a location.');
            return;
        }

        for(let i = 0; i < this.fulfillable_items.length; i++) {

            let item = this.fulfillable_items[i];
            let quantity_invalid_char = item.quantity.toString().search(/[^0-9.]/g);

            if(quantity_invalid_char == -1) {

                if(item.quantity > 0) {
                    fulfillment_has_items = true;
                }

                if(item.quantity > item.fulfillable_quantity){
                    this.presentAlert('Over fulfilled', `You have overfulfilled an item "${item.title}". The max quantity is ${item.fulfillable_quantity}.`);
                    validated = false;
                    break;
                }
                else if(item.quantity < 0) {
                    this.presentAlert('Negative quantity', `Item "${item.title}" has a negative quantity. Please make the quantity greater or equal to zero.`);
                    validated = false;
                    break;
                }
                else if(item.track_stock == 1 && item.quantity > item.stock_on_hand) {
                    this.presentAlert('Stock on hand exceeded', `Item "${item.title}" has a quantity that exceeds the stock on hand available to fulfill.`);
                    validated = false;
                    break;
                }

            }
            else {
                this.presentAlert('Invalid quantity', `Item "${item.title}" has an invalid quantity.`);
                validated = false;
                break;
            }

        }

        if(!fulfillment_has_items) {
            this.presentAlert('Empty fulfillment', 'You need at least one item.');
            validated = false;
        }

        if(validated) {

            if(this.fulfillment_params['method'] == 'dropshipped') {
                delete this.fulfillment_params['location_id'];
            }

            let items = [];
            // change lookup into array
            for(let i = 0; i < this.fulfillable_items.length; i++) {
                if(this.fulfillable_items[i].quantity > 0) {
                    items.push({
                        id: this.fulfillable_items[i].id,
                        quantity: this.fulfillable_items[i].quantity
                    });
                }
            }
            this.fulfillment_params.items = items;

            this.fulfillment_params['date'] = moment(this.fulfillment_params['date']).utc().toISOString();

            this.addFulfillment().then(() => {
                this.modalController.dismiss();
            })
            .catch(() => { });

        }
    }

    addFulfillment() {
        let fulfillment_params = { ...this.fulfillment_params };
        // collected fulfillments never send the order shipped email (toggle is left as-is in case method changes back)
        if(fulfillment_params['method'] == 'collected') {
            delete fulfillment_params['send_order_shipped_email'];
        }
        let promise = new Promise<void>((resolve, reject) => {
            this.presentSpinner("Adding fulfillment").then(() => {
                this.orderService.addOrderFulfillment(this.order.id, fulfillment_params).then(() => {
                    this.spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
        return promise;
    }

    async presentDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                componentProps: {
                    date: this.fulfillment_params['date'],
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.fulfillment_params['date'] = data.data['date'];
                    this.formatted_date = this.moment(this.fulfillment_params['date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async editItemQuantity(item) {

        let header = "";

        if(item["measurement_unit"] != undefined && item["measurement_unit"] != null) {
            header = "Quantity" + " " + "(" + item["measurement_unit"].symbol + ")";
        }
        else {
            header = "Quantity";
        }

        const alert = await this.alertController.create({
            header: header,
            cssClass:'alert',
            inputs: [{
                name: 'quantity',
                type: 'number',
                value: item.quantity,
                min: 0
            }],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, 
                {
                    text: 'Ok',
                    handler: (data) => {
                        for(let i = 0; i < this.fulfillable_items.length; i++) {
                            if(item.id == this.fulfillable_items[i].id) {

                                let fulfillable_item = this.fulfillable_items[i];

                                // if dp=0, only accept numbers (allows negative)
                                if (fulfillable_item.quantity_decimal_places == 0 && /[^0-9-]/.test(data.quantity)) {
                                    fulfillable_item.quantity = item.quantity;
                                }
                                // if dp > 0, only accept numbers/decimal points (allows negative)
                                else if (fulfillable_item.quantity_decimal_places > 0 && /[^0-9.-]/.test(data.quantity)) {
                                    fulfillable_item.quantity = item.quantity;
                                }
                                else if (fulfillable_item.quantity_decimal_places > 0 && data.quantity.startsWith('.')) {
                                    fulfillable_item.quantity = item.quantity;
                                }
                                else if (fulfillable_item.quantity_decimal_places > 0 && data.quantity.endsWith('.')) {
                                    fulfillable_item.quantity = item.quantity;
                                }
                                // if dp > 0, ensure decimal places not exceeded
                                else if (fulfillable_item.quantity_decimal_places > 0 && data.quantity.includes('.') && data.quantity.split('.')[1].length > fulfillable_item.quantity_decimal_places) {
                                    fulfillable_item.quantity = item.quantity;
                                }
                                else if (!data.quantity.length) {
                                    fulfillable_item.quantity = item.quantity;
                                }
                                else if (data.quantity < 0) {
                                    fulfillable_item.quantity = 0;
                                }
                                else if (data.quantity > fulfillable_item.fulfillable_quantity) {
                                    fulfillable_item.quantity = fulfillable_item.fulfillable_quantity;
                                }
                                else {
                                    fulfillable_item.quantity = Number(new Decimal(data.quantity).toDecimalPlaces(fulfillable_item.quantity_decimal_places));
                                }

                                break;
                            }
                        }

                    }
                }
            ]
        });
        await alert.present();
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
